import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import GetKala from "./GetKala";
import { ProductProvider } from "../context/ProductContext";

const Visitor = (props) => {
  const [data, setData] = useState({ result: true });

  useEffect(() => {
    const formData = new FormData();
    formData.append("check_visitor", 1);
    formData.append("visitor_id", props.id);
    formData.append("test", props.id);
    const myRequest = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php/",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(myRequest)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      });
  }, [props.id]);

  if (data.result === true) {
    if (data.data !== undefined) {
      const tel =
        data.data.tel !== "" ? (
          <div className="info">
            <a href={"tel:" + data.data.tel}>{data.data.tel}</a>
            <FontAwesomeIcon icon={faPhone} />
          </div>
        ) : (
          ""
        );

      const img =
        data.data.logo !== "" ? (
          <img
            src={data.data.logo}
            className="image rounded-circle"
            alt={data.data.name}
          />
        ) : (
          ""
        );

      const address =
        data.data.address !== "" ? (
          <div className="info">
            {data.data.address}
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </div>
        ) : (
          ""
        );

      const telegram =
        data.data.telegram_id !== "" ? (
          <a className="info btn-link" href={data.data.telegram_id}>
            <img
              alt="telegram"
              className="brand rounded-circle"
              src={data.data.telegram_image}
            />
          </a>
        ) : (
          ""
        );

      const website =
        data.data.website_id !== "" ? (
          <a className="info btn-link" href={data.data.website_id}>
            <img
              alt="website"
              className="brand rounded-circle"
              src={data.data.website_image}
            />
          </a>
        ) : (
          ""
        );

      const instagram =
        data.data.instagram_id !== "" ? (
          <a className="info btn-link" href={data.data.instagram_id}>
            <img
              alt="instagram"
              className="brand rounded-circle"
              src={data.data.instagram_image}
            />
          </a>
        ) : (
          ""
        );

      return (
        <div>
          <div className="card shadow rounded">
            <div className="card-header bg-white">
              <div className="h4 name">{data.data.name}</div>
              {img}
            </div>
            <div className="card-body">
              {tel}
              {address}
            </div>
            <div className="card-footer bg-white">
              {telegram}
              {instagram}
              {website}
            </div>
          </div>
          <div>
            <ProductProvider>
              <GetKala id={props.id} isVisitor={1} />
            </ProductProvider>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="card">
        <div className="m-5">{"ویزیتور یافت نشد"}</div>
      </div>
    );
  }
};

export default Visitor;
